import { render, staticRenderFns } from "./StudentSiblingReport.vue?vue&type=template&id=c21a9746&scoped=true"
import script from "./StudentSiblingReport.vue?vue&type=script&lang=js"
export * from "./StudentSiblingReport.vue?vue&type=script&lang=js"
import style0 from "./StudentSiblingReport.vue?vue&type=style&index=0&id=c21a9746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21a9746",
  null
  
)

export default component.exports